import React, { useEffect, useRef, useState } from "react"
import classnames from "classnames"
import { HUtils, MyControl, MyIcon, MyUI } from "@macashipo/mlib"
import { BiSolidMessageDetail } from "react-icons/bi"
import {
  categoryFields,
  detailFields,
  userProfileFields,
} from "src/modules/app_sigo/constants/fields"
import Skeleton from "react-loading-skeleton"
import styled from "styled-components"
import { MyModal } from "src/core/components"

const UITypes = {
  rating_n_trip: (data, config) => {
    const rating = data?.[categoryFields.fPDRate]
    const review = data?.[detailFields.fReview]
    return (
      <div className={config?.classItem}>
        {rating && (
          <span style={{ marginRight: 12 }}>
            <i className="flaticon-star mauden" style={{ fontSize: 22 }}></i>
            {rating}
          </span>
        )}
        {review?.TotalRatingCount > 0 && (
          <span>
            <BiSolidMessageDetail
              color="var(--mauden)"
              style={{ marginTop: -2, marginRight: 6 }}
              size={20}
            />
            {review?.TotalRatingCount} đánh giá
          </span>
        )}
      </div>
    )
  },
  icon_list: function MyIconList(data, config) {
    const [showMore, setShowMore] = useState(false)
    const list = data?.[config?.fieldData] || []
    const collapseShow = config.collapseShow
    const numShowDefault = config.numShowDefault || 8
    const titleShowMore = config.titleShowMore || "Hiển thị tất cả"
    const styleIcon = config?.styleIcon || {}
    if (list?.length > 0) {
      return (
        <>
          {list
            ?.slice(0, !collapseShow || showMore ? list.length : numShowDefault)
            .map((v, i) => {
              const iconUrl = v?.Icon || v?.IconUrl || ""
              let isIcon = false
              if (iconUrl && iconUrl?.startsWith("flaticon")) {
                isIcon = true
              }
              return (
                <div
                  key={i}
                  className={classnames("icon_list", config?.classOption)}
                >
                  <div className="d-flex align-items-center mb-3 one-item">
                    {isIcon ? (
                      <i className={iconUrl} style={{ ...styleIcon }} />
                    ) : (
                      <img src={v?.IconUrl} alt="" />
                    )}{" "}
                    {v?.Text}
                  </div>
                </div>
              )
            })}
          {collapseShow && numShowDefault < list?.length && (
            <>
              <div>
                <button
                  className="btn btn-default btn-show-more"
                  onClick={() => {
                    setShowMore(!showMore)
                  }}
                >
                  {showMore ? "Thu gọn" : titleShowMore}
                </button>
              </div>
            </>
          )}
        </>
      )
    }
  },
  dot_list: (data, config) => {
    const list = data?.[config?.fieldData]
    if (list?.length > 0) {
      return (
        <div className="dot-wrap">
          {list.map((v, i) => {
            return (
              <div
                key={i}
                className={classnames("dot_list", config?.classOption)}
              >
                <div
                  className="d-flex align-items-center"
                  // style={{ color: "#000" }}
                >
                  <div className="dot-icon" />
                  {v?.Text}
                </div>
              </div>
            )
          })}
        </div>
      )
    }
  },

  info: (data, config) => {
    const infoObj = data?.[detailFields.fOwnerInfo]
    const profileUrl = infoObj?.[detailFields.fOwnerInfoUrl] || "#"
    const avatarUrl = infoObj?.[categoryFields.fPDAvatarUrl]
    const name = infoObj?.[categoryFields.fPDName]
    const rating = infoObj?.[categoryFields.fPDRate]
    // const trip = infoObj?.[detailFields.fServedCount]
    // const joinDate = infoObj?.[detailFields.fJoinedDate]
    const joinWhen = infoObj?.[detailFields.fJoinedWhen]
    // const replyTime = infoObj?.[detailFields.fReplyWithin]
    return (
      <WrapInfo className={config?.classItem}>
        <div className="wrap-avatar-info">
          <a href={profileUrl}>
            <img className="avartar" src={avatarUrl} alt="" />
          </a>
        </div>
        <div>
          {/* <div className="xhsao" style={{ left: 22 }}>
          {rating} <i className="fa fa-star mau1"></i>
        </div> */}
          <span>
            Chủ xe:&nbsp;
            <span className="name">
              <a href={profileUrl}>
                <strong>{name}</strong>
              </a>{" "}
            </span>
          </span>
          {/* <div className="small d-flex align-items-center">
          {rating && (
            <span>
              <i
                className="flaticon-star mauden"
                style={{ marginRight: 4 }}
              ></i>
              {rating}
            </span>
          )}
          {infoObj?.rating > 0 && (
            <>
              <span className="dot-icon-text" />
              <span>{infoObj?.rating} Đánh giá</span>
            </>
          )}
        </div> */}
          {!!joinWhen && (
            <div className="d-flex align-items-center">
              Tham gia{" "}
              <span
                style={{ textTransform: "lowercase", marginLeft: "0.25rem" }}
              >
                {joinWhen}
              </span>
              {/* <span className="dot-icon-text" /> Thường phản
          hồi trong vòng {replyTime} */}
            </div>
          )}
        </div>

        <div className="clearfix"></div>
      </WrapInfo>
    )
  },
  description: (data, config) => {
    return (
      <div
        className="content"
        dangerouslySetInnerHTML={{ __html: data?.[config?.fieldData] }}
        style={{ color: "var(--color-text-000)", whiteSpace: "pre-line" }}
      ></div>
    )
  },
  content_collapse: (data, config) => {
    const UI = props => {
      const { data, config } = props
      const [showMore, setShowMore] = useState(false)
      return (
        <div
          className={`${config?.classItem} wpviewmore ${
            showMore ? "show" : ""
          }`}
        >
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html: HUtils.get(data, config?.fieldData),
            }}
          ></div>
          <div>
            <button
              className="viewmore"
              onClick={() => {
                setShowMore(!showMore)
              }}
            >
              {showMore ? "Thu gọn" : "Xem thêm"}
            </button>
          </div>
        </div>
      )
    }
    return <UI data={data} config={config} />
  },
  progress_bar: (data, config) => {
    const progress = config?.progress
    if (progress?.length > 0) {
      return (
        <div className="wpcshc">
          {progress.map((v, i) => {
            return (
              <div key={i} className={classnames("item", v?.className)}>
                <b>{v?.title}</b>
                <div
                  className={classnames("lineicon", v?.classNameLine)}
                  color={v?.color}
                >
                  <i className={v?.icon || "dot"} />
                  {i === progress.length - 1 && config?.endpoint && (
                    <div className="last">
                      <i className={config?.endpoint?.icon} />
                    </div>
                  )}
                </div>
                <p>{v?.description}</p>
                {i === progress.length - 1 && config?.endpoint?.title && (
                  <span className="donecd">{config.endpoint.title}</span>
                )}
              </div>
            )
          })}
          <div className="clearfix"></div>
        </div>
      )
    }
  },
  review: function Review(data, config) {
    const [showMore, setShowMore] = useState(false)
    const collapseShow = config?.collapseShow
    const numShowDefault = config?.numShowDefault || 6
    const listReviews = HUtils.get(data, config?.fieldData)
    const rating = data?.[categoryFields.fPDRate]
    const review = data?.[detailFields.fReview]
    const lengthShow =
      !collapseShow || showMore ? listReviews?.length ?? 0 : numShowDefault

    if (listReviews?.length > 0) {
      return (
        <>
          <div
            className="d-flex align-items-center"
            style={{ marginBottom: 24 }}
          >
            {rating && (
              <span style={{ marginRight: 12 }}>
                <i
                  className="flaticon-star mauden"
                  style={{ marginRight: 6, fontSize: 22 }}
                />
                <span style={{ fontSize: 20 }}>{rating}</span>
              </span>
            )}
            {review?.TotalRatingCount > 0 && (
              <span style={{ height: 28 }}>
                <BiSolidMessageDetail
                  color="var(--mauden)"
                  style={{ marginTop: -2, marginRight: 6 }}
                  size={20}
                />
                <span style={{ fontSize: 20, marginTop: -1 }}>
                  {review?.TotalRatingCount} đánh giá
                </span>
              </span>
            )}
          </div>
          <div className="row p-review">
            {listReviews?.slice(0, lengthShow).map((v, i) => {
              return (
                <div key={i} className="col-md-6">
                  <div className="dg">
                    <div className="mb-15px">
                      <img
                        className="avartar"
                        src={v?.[detailFields.fReviewByAvatarUrl]}
                        alt=""
                        style={{
                          width: 60,
                          height: 60,
                        }}
                      />
                      <div>
                        {v?.[detailFields.fRVUser] && (
                          <b className="name">{v?.[detailFields.fRVUser]}</b>
                        )}
                      </div>
                      <span className="address">
                        {v?.[detailFields.fAddress]}
                      </span>
                      <div className="clearfix"></div>
                    </div>
                    <div className="mb-15px">
                      <MyControl
                        type="input_rate"
                        defaultValue={v?.[detailFields.fRVRating]}
                        controlOpts={{
                          fieldName: detailFields.fRVRating,
                          disabled: true,
                          configRate: {
                            fieldRating: "rate",
                            total: v?.[detailFields.fRVRating],
                          },
                          onUpdateValue: val => {},
                          getDefaultValues: () => {
                            return {
                              rate: v?.[detailFields.fRVRating],
                            }
                          },
                        }}
                      />
                      <span className="time" style={{ marginLeft: 16 }}>
                        {v?.[detailFields.fRVTime]}
                      </span>
                    </div>
                    <div className="nddg">{v?.[detailFields.fRVContent]}</div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              )
            })}
          </div>
          {collapseShow && numShowDefault <= listReviews?.length && (
            <>
              <div>
                <button
                  style={{ marginTop: 0 }}
                  className="btn btn-default btn-show-more"
                  onClick={() => {
                    setShowMore(!showMore)
                  }}
                >
                  {showMore
                    ? "Thu gọn"
                    : `Hiển thị tất cả ${listReviews?.length} đánh giá`}
                </button>
              </div>
            </>
          )}
        </>
      )
    }
    return <></>
  },
  vehicle_map: (data, config) => {
    const address = data[detailFields.fAddress]
    const _DeliveryInfo = data?.[detailFields.fDeliveryInfo] || {}
    const { UserTakeLat, UserTakeLng } = _DeliveryInfo
    return (
      <>
        <p className="vehicle-address">{address}</p>
        <MyUI
          type="sg_vehicle_map"
          data={{ longitude: UserTakeLng, latitude: UserTakeLat }}
        />
      </>
    )
  },
  vehicle_need: (data, config) => {
    const _thingsToKnow = data?.[detailFields.fThingsToKnow] ?? []

    return (
      <div className="row need-wrap">
        {_thingsToKnow?.map((v, i) => {
          return (
            <div
              className={classnames("icon_list", config?.classOption)}
              key={i}
            >
              <div className="title">{v.Title}</div>
              <div className="description">{v.Description}</div>
              {v?.Content && (
                <button
                  className="btn btn-link show-content"
                  onClick={() => {
                    MyModal.showFromComponent(
                      <div
                        dangerouslySetInnerHTML={{
                          __html: v?.Content,
                        }}
                      ></div>,
                      {
                        title: v.Title,
                        modalClassName:
                          "default modal-filter modal-scrollable-inside",
                        modalScrollInside: true,
                      }
                    )
                  }}
                >
                  Hiển thị thêm
                </button>
              )}
            </div>
          )
        })}
      </div>
    )
  },
  booking_feature: function MyUIBookingFeature(data, config) {
    const list = data?.[config?.fieldData] || []
    if (list?.length > 0) {
      const element = document.getElementById("detail_insurance_more")
      if (element) {
        const insuranceInfo = data?.[detailFields.fInsuranceInfo] || {}
        if (insuranceInfo) {
          element.addEventListener("click", () => {
            MyModal.showFromComponent(
              <>
                {insuranceInfo?.Content && (
                  <div
                    dangerouslySetInnerHTML={{ __html: insuranceInfo?.Content }}
                  ></div>
                )}
              </>,
              {
                title: insuranceInfo?.Title ? insuranceInfo?.Title : "",
                modalClassName: "default modal-filter modal-scrollable-inside",
                modalScrollInside: true,
              }
            )
          })
        }
      }
      return (
        <>
          {list.map((v, i) => {
            const icon = v?.Icon
            const description = v?.Description || ""
            const title = v?.Title
            return (
              <WrapBookingFeature
                className="one-booking-feature"
                key={`feature-${i}`}
              >
                {icon && <MyIcon data={`type:${icon}`} />}
                <div className="wrap-content">
                  <div className="title">{title}</div>
                  <div
                    className="des"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></div>
                </div>
              </WrapBookingFeature>
            )
          })}
        </>
      )
    }
  },
}
const MyUIProduct = props => {
  const { data, loading, parts, className } = props

  const renderLoading = () => {
    return (
      <WrapLoading>
        <Skeleton height={"100%"} />
      </WrapLoading>
    )
  }
  if (loading) {
    return renderLoading()
  }
  return (
    <Wrap className={className}>
      {parts?.length > 0 &&
        parts.map((v, i) => {
          if (v?.canShow === false) {
            return <></>
          }
          return (
            <div
              key={i}
              id={v.id}
              className={classnames("divitem row", v.classWrap)}
            >
              {v.showDivider && <hr className="hr10p mb-25px"></hr>}
              {v.title && <h5 className="title-xanh">{v.title}</h5>}
              {UITypes?.[v.type] ? UITypes[v.type](data, v) : null}
            </div>
          )
        })}
    </Wrap>
  )
}
const WrapInfo = styled.div`
  display: flex;
  align-items: center;
  & .wrap-avatar-info {
    width: 40px;
    height: 40px;
    margin-right: 20px;
    // margin-top: 6px;
    & img {
      width: 40px;
      height: 40px;
      min-width: 40px !important;
    }
  }
`
const WrapBookingFeature = styled.div`
  display: flex;
  margin-bottom: 30px;
  align-items: flex-start;
  & svg {
    width: 30px;
    height: 30px;
    margin-top: 5px;
  }
  & .wrap-content {
    padding-left: 30px;
  }
  & .title {
    color: #404040;
    font-weight: 700;
    line-height: 24px;
  }
  & .des {
    color: #666666;
    line-height: 22px;
    white-space: pre-line;
  }
  &:last-child {
    margin-bottom: 0px;
  }
`
const WrapLoading = styled.div`
  height: 100px;
`
const Wrap = styled.div`
  & .title-xanh {
    font-size: 22px;
  }
  & .things-to-know {
    & .title-xanh {
      margin-top: 12px;
      margin-bottom: 16px;
    }
  }
  & .ttcx {
    img {
      min-width: 70px;
    }
  }
  & .vehicle-map {
    & .title-xanh {
      margin-top: 12px;
      margin-bottom: 6px;
    }
    & .vehicle-address {
      margin-bottom: 32px;
      margin-top: 10px;
    }
  }
  & [class*="col-"] {
    &.icon_list {
      & img {
        height: 32px;
        width: 32px;
        margin-right: 8px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  & .icon_list {
    & .one-item {
      color: var(--color-text-000);
    }
  }
  & .dot-icon-text {
    height: 4px;
    width: 4px;
    margin-left: 6px;
    margin-right: 6px;
    border-radius: 4px;
    background: #515151;
    display: inline-block;
  }
  & .dot-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-left: -18px;
    padding-left: 0;
    padding-right: 0;
  }
  & .dot_list {
    width: unset;
    max-width: unset;
    padding-left: 0;
    padding-right: 16px;
    & .dot-icon {
      height: 5px;
      width: 5px;
      margin-right: 16px;
      border-radius: 5px;
      background: #000;
    }
  }
  & .character-istics {
    margin-left: 0px;
    overflow: hidden;
  }
  & .character-istics {
    margin-left: 0px;
    overflow: hidden;
  }
  & .description-vehicle {
    h5 {
      margin-bottom: 16px;
    }
  }
  & .features-vehicle {
    h5 {
      margin-bottom: 16px;
    }
  }
  & .viewmore {
    background-color: #fff;
  }
  & .need-wrap {
    & [class*="col-"] {
      margin-bottom: 12px;
    }
    .need-item .title {
      color: var(--den);
      font-weight: bold;
    }
    & .btn-link {
      border: none !important;
      text-decoration: underline;
      color: var(--den);
      margin-top: 20px;
      font-weight: bold;
    }
    & .description {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* Số dòng tối đa */
      -webkit-box-orient: vertical;
    }
  }
  & .wpcshc {
    margin-bottom: 25px;
    & .item {
      float: left;
      position: relative;
      min-height: 80px;
      width: 33.33%;
    }
    & b {
      margin-bottom: 15px;
      display: block;
      font-size: 13px;
    }
    & p {
      padding-left: 20px;
      font-size: 13px;
    }
    & .lineicon {
      height: 4px;
      background-color: #3d6eeb;
      position: relative;
      margin-bottom: 10px;
    }
    & .lineicon i {
      position: absolute;
      left: 4px;
      top: -6px;
      color: white;
      line-height: 20px;
      font-size: 15px;
      z-index: 3;
    }
    & .lineicon i.dot {
      width: 15px !important;
      height: 15px !important;
      top: -5px;
      left: 5px;
      display: block;
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: #fff;
    }
    & .lineicon:before {
      content: "";
      height: 25px;
      width: 25px;
      background-color: #3d6eeb;
      position: absolute;
      border-radius: 50%;
      left: 0px;
      top: -10px;
      z-index: 1;
    }
    & .lineicon:after {
      content: "";
      height: 60px;
      width: 1px;
      background-color: #3d6eeb;
      position: absolute;
      left: 13px;
      top: 0px;
      z-index: 1;
    }
    & .bg2:after,
    & .bg2:before,
    & .bg2 {
      background: #f1c243;
    }
    & .bg3:after,
    & .bg3:before,
    & .bg3,
    & .bg3 .last {
      background: #af2d1e;
    }
    & .bg3 .last {
      content: "";
      height: 25px;
      width: 25px;
      position: absolute;
      border-radius: 50%;
      right: 0px;
      top: -9px;
      z-index: 1;
      line-height: 25px;
      color: white;
      vertical-align: middle;
    }
    & .bg3 .last i {
      top: 4px;
      font-size: 17px;
    }
    & .donecd {
      position: absolute;
      right: 0px;
      top: 10px;
      font-size: 13px;
      font-weight: bold;
      width: auto !important;
    }
    @media (min-width: 768px) {
      & .item2 b,
      & .item3 b,
      & .donecd {
        display: block;
        width: 150px;
        margin-left: -60px;
        text-align: center;
      }
    }
    @media (max-width: 480px) {
      & .item3 b {
        margin-left: -25px;
      }
    }
    @media (max-width: 414px) {
      & b,
      & .donecd {
        letter-spacing: -1px;
        font-weight: normal;
      }
    }
  }
  @media (min-width: 768px) {
    & .need-wrap {
      margin-left: -24px;
      margin-right: -24px;
      padding-right: 0;
      & [class*="col-"] {
        padding-left: 24px;
        padding-right: 24px;
      }
    }
  }
  & .p-review {
    & .name {
      margin-right: 0.25rem;
    }
    & .mc_input_rate {
      display: inline-block;
      & .react-rater {
        font-size: 1rem;
      }
      &.disabled {
        opacity: 1;
      }
      & .react-rater-star {
        &.is-active {
          color: var(--vang);
        }
      }
    }
  }
`
export default MyUIProduct
